'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _queue = require('./queue');

var _queue2 = _interopRequireDefault(_queue);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */


/**
 * 默认自动重试2次
 * @type {number}
 */
var MAX_RETRY_COUNT = 2;

var LazyLoad = function (_Component) {
  _inherits(LazyLoad, _Component);

  function LazyLoad(props) {
    _classCallCheck(this, LazyLoad);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    var _this$props = _this.props,
        src = _this$props.src,
        maxConnection = _this$props.maxConnection,
        maxRetryCount = _this$props.maxRetryCount;

    // 存储组件的原src

    _this.resource = src || '';
    // 默认重试最大次数
    _this.maxRetryCount = maxRetryCount || MAX_RETRY_COUNT;
    // 当前重试次数
    _this.retryCount = 0;

    // initial state
    _this.state = {
      src: '',
      isRetry: false
    };

    // 指定最大连接数
    if (maxConnection) {
      _queue2.default.setMaxConnection(maxConnection);
    }
    return _this;
  }

  LazyLoad.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var src = nextProps.src,
        showImmediately = nextProps.showImmediately;

    if (src !== this.resource || this.props.showImmediately !== showImmediately) {
      // 重置相应信息
      this.resource = src || '';
      this.loaded = false;
      // this.state.isRetry = false;
      this.setState({
        isRetry: false
      });
      if (showImmediately) {
        this.load(this.resource);
      } else {
        // 加入队列
        _queue2.default.add(this);
      }
    }
  };

  LazyLoad.prototype.componentDidMount = function componentDidMount() {
    // set 标志位
    this.mounted = true;

    var showImmediately = this.props.showImmediately;

    if (showImmediately) {
      this.load(this.resource);
    } else {
      // 加入队列
      _queue2.default.add(this);
    }
  };

  LazyLoad.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  LazyLoad.prototype.getAttr = function getAttr() {
    var src = this.state.src || '';
    // 默认标签为img
    this.tag = this.props.tag || 'img';
    // 继承属性值
    var attr = Object.assign({}, this.props);

    // 删除src等属性，避免污染自有属性
    ['src', 'onLoad', 'onError', 'showImmediately', 'placeholder', 'onLoadStart', 'onLoadSuccess', 'onLoadFail', 'onRetryStart', 'onRetrySuccess', 'onRetryFail'].forEach(function (key) {
      delete attr[key];
    });

    // src为空时，创建空的div替代，因为img会出现边框
    if (!src) {
      this.tag = 'div';
      // 占位封面图
      var placeholder = this.props.placeholder;


      if (placeholder) {
        var style = {};
        if (/^#.*$/g.test(placeholder)) {
          // 纯色
          style.backgroundColor = placeholder;
        } else {
          style.backgroundImage = 'url(' + placeholder + ')';
        }
        attr.style = Object.assign({}, attr.style, style);
      }
      return attr;
    }

    // 跟进标签类型决定属性赋值
    switch (this.tag) {
      case 'div':
        attr.style = Object.assign({}, attr.style, {
          backgroundImage: 'url(' + src + ')'
        });
        break;
      default:
        attr.src = src;
        break;
    }

    return attr;
  };

  /**
   * 加载图片
   * @param src
   */


  LazyLoad.prototype.load = function load(src) {
    var _this2 = this;

    if (!src) return;

    var image = new Image();
    image.onload = function () {
      _this2.onLoad(src);
    };
    image.onerror = function () {
      _this2.onError(src);
    };
    image.src = src;

    // 通知已经开始加载
    this.onStart(src);
  };

  /**
   * 显示组件图片
   * @param src
   * @param isRetry 是否是重试
   */


  LazyLoad.prototype.show = function show(src, isRetry) {
    if (this.mounted) {
      this.setState(Object.assign({}, this.state, {
        src: src || this.resource,
        isRetry: isRetry
      }));
    }
  };

  /**
   * 加载重试
   * @param isManu 是否是手动重试
   */


  LazyLoad.prototype.retry = function retry(isManu) {
    var _this3 = this;

    // 超过最大重试次数并且是自动重试，不重试
    if (this.retryCount >= this.maxRetryCount && !isManu) return;

    // 根据当前重试次数，决定不同重试策略
    var retrySrc = this.resource;
    switch (this.retryCount) {
      case 0:
        // 第一次，https回退到http
        retrySrc = (0, _util.downGrade)(retrySrc);
        break;
      case 1:
        // 第二次，https回退到http
        retrySrc = (0, _util.downGrade)(retrySrc);

        break;
      default:
        break;
    }

    // 拼接时间戳重试，保证一定是新的请求
    retrySrc = (0, _util.appendTimestamp)(retrySrc);

    // 开始重试
    var image = new Image();
    // 赋值属性
    image.onload = function () {
      _this3.onRetrySuccess(retrySrc);
    };
    image.onerror = function () {
      _this3.onRetryFail(retrySrc, isManu);
    };
    image.src = retrySrc;
    // onRetryStart
    this.onRetryStart(retrySrc);

    // 更新重试次数
    this.retryCount++;
  };

  /**
   * 检测组件是否Mounted
   */


  LazyLoad.prototype.validateMounted = function validateMounted() {
    return this.mounted;
  };

  /**
   * 图片开始加载
   */


  LazyLoad.prototype.onStart = function onStart() {
    // 标志组件已经开始加载
    this.loadStarted = true;

    // 组件未移除
    if (this.validateMounted()) {
      var onLoadStart = this.props.onLoadStart;


      onLoadStart && onLoadStart(this);
    }

    // static
    LazyLoad.onLoadStart && LazyLoad.onLoadStart(this);
  };

  /**
   * 图片加载成功
   */


  LazyLoad.prototype.onLoad = function onLoad(src) {
    // 标记加载过的标志
    this.loaded = true;

    // 组件未移除
    if (this.validateMounted()) {
      var onLoadSuccess = this.props.onLoadSuccess;

      // 加载成功之后才放入DOM

      this.show(src, false);

      onLoadSuccess && onLoadSuccess(this);
    }

    // static
    LazyLoad.onLoadSuccess && LazyLoad.onLoadSuccess(this);
  };

  /**
   * 图片加载失败
   */


  LazyLoad.prototype.onError = function onError() {
    // 组件未移除
    if (this.validateMounted()) {
      var onLoadFail = this.props.onLoadFail;

      // 自动重试

      this.retry();

      onLoadFail && onLoadFail(this);
    }

    // static
    LazyLoad.onLoadFail && LazyLoad.onLoadFail(this);
  };

  /**
   * 重试开始
   * @param retrySrc
   */


  LazyLoad.prototype.onRetryStart = function onRetryStart(retrySrc) {
    // 标志组件已经开始加载
    this.loadStarted = true;

    // 组件未移除
    if (this.validateMounted()) {
      var onRetryStart = this.props.onRetryStart;


      onRetryStart && onRetryStart(this);
    }

    // static
    LazyLoad.onRetryStart && LazyLoad.onRetryStart(this);
  };

  /**
   * 重试成功
   * @param retrySrc
   */


  LazyLoad.prototype.onRetrySuccess = function onRetrySuccess(retrySrc) {
    // 标记加载过的标志
    this.loaded = true;

    // 组件未移除
    if (this.validateMounted()) {
      var onRetrySuccess = this.props.onRetrySuccess;

      // 重试成功，直接显示

      this.show(retrySrc, true);

      onRetrySuccess && onRetrySuccess(this);
    }

    // static
    LazyLoad.onRetrySuccess && LazyLoad.onRetrySuccess(this);
  };

  /**
   * 重试失败
   * @param retrySrc
   * @param isManu 是否是手动重试
   */


  LazyLoad.prototype.onRetryFail = function onRetryFail(retrySrc, isManu) {
    // 组件未移除
    if (this.validateMounted()) {
      var onRetryFail = this.props.onRetryFail;


      if (!isManu) {
        // 自动逻辑下，失败之后继续重试
        this.retry();
      }

      onRetryFail && onRetryFail(this);
    }

    // static
    LazyLoad.onRetryFail && LazyLoad.onRetryFail(this);
  };

  LazyLoad.prototype.render = function render() {
    var _this4 = this;

    var attr = this.getAttr();

    return _react2.default.createElement(this.tag, Object.assign(attr, {
      ref: function ref(c) {
        _this4.dom = c;
      }
    }), this.props.children || null);
  };

  return LazyLoad;
}(_react.Component);

exports.default = LazyLoad;


LazyLoad.defaultProps = {
  showImmediately: true
};

LazyLoad.propTypes = {
  src: _propTypes2.default.string,
  maxConnection: _propTypes2.default.number,
  maxRetryCount: _propTypes2.default.number,
  showImmediately: _propTypes2.default.bool,
  children: _propTypes2.default.element,
  tag: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  onLoadStart: _propTypes2.default.func,
  onLoadSuccess: _propTypes2.default.func,
  onLoadFail: _propTypes2.default.func,
  onRetryStart: _propTypes2.default.func,
  onRetrySuccess: _propTypes2.default.func,
  onRetryFail: _propTypes2.default.func
};